import { ColumnHelperMethodType } from '../SearchContentTable.types';
import { getViews } from '../SearchContentTable.utils';
import { TextCell } from '../components/TextCell';

export const ColumnViews: ColumnHelperMethodType = (columnHelper) => {
  return columnHelper.accessor((row) => row.contentId, {
    id: 'Views',
    cell: ({ row }) => <TextCell>{getViews(row.original)}</TextCell>,
  });
};
